'use client';

import type { ReactNode } from 'react';
import useStyles from './styles';

export const CategoryHeader = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <section className={classes.header}>{children}</section>;
};

const CategorySection = ({ children, category }: { children: ReactNode; category: string }) => {
  const classes = useStyles();
  return (
    <section className={classes.section} data-pulse-section={category} data-pulse-group={category}>
      {children}
    </section>
  );
};

export default CategorySection;
